import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from '@boma/app-config';
import { SyncJobType } from '../../../../entities/src/lib/enums/sync-job-type';
import { IPaginatedResponse } from '@boma/supplier-portal/shared/entities';
import { IAccountingSyncJob } from '../../../../entities/src/lib/definitions/i-accounting-sync-job';
import { IAccountingSyncJobItem } from '../../../../entities/src/lib/definitions/i-accounting-sync-job-item';

@Injectable()
export class AccountingSyncJobsService {
  private readonly base: string;
  private readonly version: string;

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private configuration: any
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listLatestSyncJobs(
    entityId: string,
    requestBody: { syncJobTypes: SyncJobType[] }
  ) {
    return this.http.post<{ items: IAccountingSyncJob[] }>(
      `${this.base}api/v${this.version}/${entityId}/syncjobs/list/latest`,
      { ...requestBody }
    );
  }

  listSyncJobs(
    entityId: string,
    page: number,
    pageSize: number,
    requestBody: {
      syncJobIds: string[];
      types: SyncJobType[];
      startDate?: Date;
      endDate?: Date;
    }
  ) {
    return this.http.post<IPaginatedResponse<IAccountingSyncJob>>(
      `${this.base}api/v${this.version}/${entityId}/syncjobs/list`,
      { ...requestBody },
      {
        params: {
          page,
          pageSize,
        },
      }
    );
  }

  listSyncJobItems(
    entityId: string,
    page: number,
    pageSize: number,
    requestBody: {
      syncJobIds: string[];
      types: SyncJobType[];
      startDate?: Date;
      endDate?: Date;
    }
  ) {
    return this.http.post<IPaginatedResponse<IAccountingSyncJobItem>>(
      `${this.base}api/v${this.version}/${entityId}/syncjobs/items/list`,
      { ...requestBody },
      {
        params: {
          page,
          pageSize,
        },
      }
    );
  }
}
